import { render, staticRenderFns } from "./duoTileView.vue?vue&type=template&id=04e2c4b2&scoped=true&"
import script from "./duoTileView.vue?vue&type=script&lang=js&"
export * from "./duoTileView.vue?vue&type=script&lang=js&"
import style0 from "./duoTileView.vue?vue&type=style&index=0&id=04e2c4b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2c4b2",
  null
  
)

export default component.exports